<template>
  <div :class="clContainer()">
    <span
      v-if="!hideLabelState || state != hideLabelState"
      :class="clSub('label', 'label')"
      >{{ label }}</span
    >
    <p :class="clSub('value', textClass)">{{ text }}</p>

    <div :class="clSub('input')">
      <v-date-picker
        :mode="mode"
        v-model="data"
        tint-color="#FF9956"
        @input="
          validate();
          dataChanged(true);
          setDate();
        "
        :popover="Object.assign(popoverBaseOptions, popoverOptions)"
      >
        <input
          id="date"
          slot-scope="props"
          v-model="props.inputValue"
          :name="name"
          :class="'form__input ' + inputClass"
          :tabindex="tabindex"
          @input="
            props.updateValue($event.target.value);
            validate();
            dataChanged(true);
          "
          @focus="focused"
        />
      </v-date-picker>
    </div>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";
import { DatePicker } from "v-calendar";
import { isPlainObject } from "../../../helpers/common";

export default {
  extends: Base,
  components: {
    DatePicker,
  },
  props: {
    typeClass: {
      type: String,
      default: "date",
    },
    mode: {
      type: String,
      default: "single",
    },
    popoverBaseOptions: {
      type: Object,
      default() {
        return { placement: "auto", visibility: "hover-focus" };
      },
    },
    popoverOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    dateStringOptions: {
      type: Object,
      default: () => {
        return { month: "2-digit", day: "2-digit", year: "numeric" };
      },
    },
    ignoreUserChangeAfterSet: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: null,
    };
  },
  created() {
    this.addDataProcessor(this.setDateData, "set");
    this.addDataProcessor((newData) => {
      this.dataChanged();
    }, "setAfter");

    this.data = this.parseDateValue(this.value);
  },
  computed: {
    text() {
      let text = "";

      if (this.data && typeof this.data == "object") {
        if (this.data instanceof Date) {
          text = this.data.toLocaleDateString("de-DE", this.dateStringOptions);
        } else {
          if ("start" in this.data) {
            text = this.data.start.toLocaleDateString(
              "de-DE",
              this.dateStringOptions
            );
          }
          if ("end" in this.data) {
            text +=
              " - " +
              this.data.end.toLocaleDateString("de-DE", this.dateStringOptions);
          }
        }
      } else {
        text = this.noValText;
      }

      return text;
    },
  },
  methods: {
    setDate() {
      this.$emit("setDate", this.data);
    },
    parseDateValue(val) {
      if (typeof val == "object") {
        if (val instanceof Date) {
          return val;
        } else if (val) {
          let varArr = [];
          if ("start" in val) {
            varArr.push(val.start);
          }
          if ("end" in val) {
            varArr.push(val.end);
          }
          val = varArr;
        }
      } else {
        val = val.toString();

        if (val.length) {
          val = val.split(";");
        }
      }

      if (val && val.length) {
        for (var i in val) {
          let dateVal = val[i];

          if (typeof dateVal == "object" && dateVal instanceof Date) {
            continue;
          }

          val[i] = isNaN(dateVal)
            ? new Date(dateVal)
            : new Date(parseInt(dateVal) * 1000);
        }

        if (this.mode == "range") {
          return {
            start: val[0],
            end: val.length > 1 ? val[1] : null,
          };
        } else {
          return val[0];
        }
      }

      return null;
    },
    setDateData(newData) {
      return this.parseDateValue(newData);
    },
  },
};
</script>